import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import MaskedInput from "react-text-mask";
import { createAutoCorrectedDatePipe } from "text-mask-addons";
import { useStateStrict, useShallowEffect } from "@ajayvikas/react-common";
const timePipe = createAutoCorrectedDatePipe("HH MM");
const PH = "0";
const toString = (value) => {
    if (!value)
        return undefined;
    const { hh: hhNum, mm: mmNum } = value;
    const { hh, mm } = { hh: hhNum ? hhNum.toString() : "", mm: mmNum ? mmNum.toString() : "" };
    return `${hh.padStart(2, PH)}:${mm.padStart(2, PH)}`;
};
const fromString = (value) => {
    if (!value)
        return { hh: 0, mm: 0 };
    const [hh, mm] = value.split(":").map(x => parseInt(x));
    return { hh: hh ?? 0, mm: mm ?? 0 };
};
export const TimeInput = React.forwardRef((props, forwardRef) => {
    const { onChange, onBlur: propsOnBlur, ...rest } = props;
    const [value, setValue] = useStateStrict(toString(props.value));
    useShallowEffect(() => {
        setValue(toString(props.value));
    }, [props.value, setValue]);
    const setRef = React.useCallback((ref) => {
        if (forwardRef) {
            if (typeof forwardRef === "function") {
                forwardRef(ref?.inputElement);
            }
            else {
                forwardRef.current = ref?.inputElement;
            }
        }
    }, [forwardRef]);
    const onInput = (e) => {
        const inputValue = e.target.value;
        setValue(inputValue);
    };
    const onBlur = (e) => {
        const obj = fromString(value);
        // setValue(toString(obj));
        onChange?.(obj);
        propsOnBlur?.(e);
    };
    return _jsx(MaskedInput, { ref: setRef, ...rest, mask: [/\d/, /\d/, ':', /\d/, /\d/], pipe: timePipe, guide: true, showMask: true, value: value, onChange: onInput, placeholderChar: "0", onBlur: onBlur });
});
